import * as c from '../CollectionConfigurations'
import type { CollectionBuildRequestConfig } from './CollectionBuilder.types'

const collections: CollectionBuildRequestConfig[] = [
  c.HarmonyPackageConfig,
  c.HarmonyPackageBoardConfig,
  c.HarmonyPackageBoardColumnConfig,
  c.HarmonyPackageBoardWorkitemConfig,
  c.HarmonyPackageBoardWorkitemColumnHistoryConfig,
  c.HarmonyPackageDocumentConfig,
  c.HarmonyPackageFolderConfig,
  c.HarmonyWorkitemConfig,
  c.TeamConfig,
  c.TeamIterationConfig,
  c.TeamMembershipConfig,
  c.TeamIntegrationConfig,
  c.TeamTagConfig,
  c.WorkitemConfig,
  c.WorkspaceConfig,
  c.WorkspaceMembershipConfig,
  c.WorkspaceMemberUserConfig,
  c.WorkitemTagConfig,
  c.UserConfig,
  c.TeamReferenceStoryConfig,
  c.IntegrationProviderConfig,
]

export function registerAllCollectionBuilders(
  register: (table: string, builder: CollectionBuildRequestConfig) => void,
) {
  collections.forEach((collection) => register(collection.table, collection))
}
